import { render, staticRenderFns } from "./ImageeditorCom.vue?vue&type=template&id=1513122c&scoped=true"
import script from "./ImageeditorCom.vue?vue&type=script&lang=js"
export * from "./ImageeditorCom.vue?vue&type=script&lang=js"
import style0 from "./ImageeditorCom.vue?vue&type=style&index=0&id=1513122c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1513122c",
  null
  
)

export default component.exports